import type { AxiosError } from "axios";

import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";

export class UseCaseGetJobById {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async (id: string) => {
    try {
      const url: IRoutes.Endpoints.Expert.Jobs.GetJobById["url"] =
        `/expert/job/${id}` as IRoutes.Endpoints.Expert.Jobs.GetJobById["url"];

      type Output = IRoutes.Endpoints.Expert.Jobs.GetJobById["outputData"];

      const result = await this.repository.findOne<Output>(String(url));

      return result;
    } catch (error) {
      if ((error as AxiosError)?.status !== 404) {
        console.error(error);
        throw error;
      }
      return null;
    }
  };
}
